"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyTokenAddress = exports.WarningMessage = exports.TradeSize = exports.TradeSizeValue = exports.DisclaimerText = exports.OrderSummaryLimitPrice = exports.OrderSummaryPriceCompare = exports.OrderSummaryLimitPriceToggle = exports.OutputAddress = exports.AcceptDisclaimer = exports.OrderSummaryTokenDisplay = exports.OrderSummaryModalContainer = exports.OrderSummarySwipeContainer = exports.OrderSummaryDetails = exports.OrderSummaryDetailsDeadline = exports.OrderSummaryDetailsOrderType = exports.OrderSummaryDetailsChunkSize = exports.OrderSummaryDetailsTotalChunks = exports.OrderSummaryDetailsTradeInterval = exports.OrderSummaryDetailsMinDstAmount = exports.MinDstAmountOut = exports.TradeIntervalAsText = exports.OrderType = exports.Deadline = exports.ChunksAmount = exports.TotalChunks = exports.FillDelayWarning = exports.PartialFillWarning = exports.PoweredBy = exports.MarketPrice = exports.LimitPriceInput = exports.useLimitPriceComponents = exports.SubmitButton = exports.TokenUSD = exports.TokenBalance = exports.ChunksUSD = exports.LimitPriceRadioGroup = exports.LimitPriceToggle = exports.TokenSelectModal = exports.TradeIntervalSelector = exports.TokenSymbol = exports.TokenSelectNew = exports.TokenSelect = exports.TokenLogoAndSymbol = exports.TokenLogo = exports.TokenInput = exports.MaxDurationSelector = exports.ChangeTokensOrder = exports.ChunksSliderSelect = exports.ChunksInput = void 0;
exports.TxSuccess = exports.TxLoading = exports.DstToken = exports.SrcToken = exports.ResetLimitButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var base_1 = require("./base");
var material_1 = require("@mui/material");
var context_1 = require("../context");
var AiOutlineWarning_1 = require("@react-icons/all-files/ai/AiOutlineWarning");
var RiArrowUpDownLine_1 = require("@react-icons/all-files/ri/RiArrowUpDownLine");
var HiSwitchHorizontal_1 = require("@react-icons/all-files/hi/HiSwitchHorizontal");
var hooks_1 = require("../hooks");
var store_1 = require("../store");
var styles_1 = require("../styles");
var TokenDisplay_1 = __importDefault(require("./base/TokenDisplay"));
var TokenSelectButton_1 = __importDefault(require("./base/TokenSelectButton"));
var Labels_1 = require("./Labels");
var material_2 = require("@mui/material");
var Copy_1 = __importDefault(require("./base/Copy"));
var config_1 = require("../config");
var __1 = require("..");
var PendingTxModal_1 = __importDefault(require("./base/PendingTxModal"));
var SuccessTxModal_1 = __importDefault(require("./base/SuccessTxModal"));
var IoIosArrowDown_1 = require("@react-icons/all-files/io/IoIosArrowDown");
var GrPowerReset_1 = require("@react-icons/all-files/gr/GrPowerReset");
function ChunksInput(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, showDefault = _a.showDefault;
    var translations = (0, context_1.useTwapContext)().translations;
    var chunks = (0, store_1.useTwapStore)(function (store) { return store.getChunks(); });
    var maxPossibleChunks = (0, store_1.useTwapStore)(function (store) { return store.getMaxPossibleChunks(); });
    var setChunks = (0, store_1.useTwapStore)(function (store) { return store.setChunks; });
    var getChunksBiggerThanOne = (0, store_1.useTwapStore)(function (store) { return store.getChunksBiggerThanOne(); });
    if (!getChunksBiggerThanOne && !showDefault) {
        return (0, jsx_runtime_1.jsx)(styles_1.StyledText, __assign({ className: className }, { children: chunks || "-" }));
    }
    return ((0, jsx_runtime_1.jsx)(base_1.Tooltip, __assign({ text: translations.sliderMinSizeTooltip }, { children: (0, jsx_runtime_1.jsx)(StyledChunksInput, { className: className, placeholder: "0", value: chunks, decimalScale: 0, maxValue: maxPossibleChunks.toString(), onChange: function (value) { return setChunks(Number(value)); } }) })));
}
exports.ChunksInput = ChunksInput;
function ChunksSliderSelect(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, showDefault = _a.showDefault;
    var getChunksBiggerThanOne = (0, store_1.useTwapStore)(function (store) { return store.getChunksBiggerThanOne(); });
    var maxPossibleChunks = (0, store_1.useTwapStore)(function (store) { return store.getMaxPossibleChunks(); });
    var chunks = (0, store_1.useTwapStore)(function (store) { return store.getChunks(); });
    var setChunks = (0, store_1.useTwapStore)(function (store) { return store.setChunks; });
    if (!getChunksBiggerThanOne && !showDefault)
        return null;
    return (0, jsx_runtime_1.jsx)(StyledChunksSliderSelect, { className: className, maxTrades: maxPossibleChunks, value: chunks, onChange: setChunks });
}
exports.ChunksSliderSelect = ChunksSliderSelect;
var ChangeTokensOrder = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.icon, icon = _c === void 0 ? (0, jsx_runtime_1.jsx)(RiArrowUpDownLine_1.RiArrowUpDownLine, {}) : _c;
    var switchTokens = (0, hooks_1.useSwitchTokens)();
    return ((0, jsx_runtime_1.jsx)(styles_1.StyledRowFlex, __assign({ className: "".concat(className, " twap-change-tokens-order") }, { children: (0, jsx_runtime_1.jsx)(base_1.IconButton, __assign({ onClick: switchTokens }, { children: children || (0, jsx_runtime_1.jsx)(base_1.Icon, { icon: icon }) })) })));
};
exports.ChangeTokensOrder = ChangeTokensOrder;
function MaxDurationSelector(_a) {
    var placeholder = _a.placeholder;
    var duration = (0, store_1.useTwapStore)(function (store) { return store.getDurationUi(); });
    var onChange = (0, store_1.useTwapStore)(function (store) { return store.setDuration; });
    return (0, jsx_runtime_1.jsx)(base_1.TimeSelector, { placeholder: placeholder, value: duration, onChange: onChange });
}
exports.MaxDurationSelector = MaxDurationSelector;
var TokenInput = function (_a) {
    var isSrc = _a.isSrc, placeholder = _a.placeholder, _b = _a.className, className = _b === void 0 ? "" : _b;
    // src
    var srcDecimals = (0, store_1.useTwapStore)(function (store) { var _a; return (_a = store.srcToken) === null || _a === void 0 ? void 0 : _a.decimals; });
    var srcUsdLoading = (0, hooks_1.useLoadingState)().srcUsdLoading;
    var srcAmount = (0, store_1.useTwapStore)(function (store) { return store.srcAmountUi; });
    var setSrcAmountUi = (0, store_1.useTwapStore)(function (store) { return store.setSrcAmountUi; });
    var srcInputLoading = (!!srcAmount || srcAmount !== "0") && srcUsdLoading;
    // dst
    var dstDecimals = (0, store_1.useTwapStore)(function (store) { var _a; return (_a = store.dstToken) === null || _a === void 0 ? void 0 : _a.decimals; });
    var dstUsdLoading = (0, hooks_1.useLoadingState)().dstUsdLoading;
    var dstAmount = (0, store_1.useTwapStore)(function (store) { return store.getDstAmountUi(); });
    var isLimitOrder = (0, store_1.useTwapStore)(function (store) { return store.isLimitOrder; });
    var dstInputLoading = (!!dstAmount || dstAmount !== "0") && dstUsdLoading;
    return ((0, jsx_runtime_1.jsx)(base_1.NumericInput, { className: "".concat(className, " twap-token-input"), decimalScale: isSrc ? srcDecimals : dstDecimals, prefix: isSrc ? "" : isLimitOrder ? "≥" : config_1.SQUIGLE, loading: isSrc ? srcInputLoading : dstInputLoading, disabled: !isSrc, placeholder: placeholder, onChange: isSrc ? setSrcAmountUi : function () { }, value: isSrc ? srcAmount : dstAmount }));
};
exports.TokenInput = TokenInput;
var TokenLogo = function (_a) {
    var isSrc = _a.isSrc, _b = _a.className, className = _b === void 0 ? "" : _b;
    var token = (0, hooks_1.useToken)(isSrc);
    return (0, jsx_runtime_1.jsx)(base_1.TokenLogo, { className: className, logo: token === null || token === void 0 ? void 0 : token.logoUrl });
};
exports.TokenLogo = TokenLogo;
function TokenLogoAndSymbol(_a) {
    var isSrc = _a.isSrc, reverse = _a.reverse;
    var token = (0, hooks_1.useToken)(isSrc);
    return (0, jsx_runtime_1.jsx)(TokenDisplay_1.default, { reverse: reverse, logo: token === null || token === void 0 ? void 0 : token.logoUrl, symbol: token === null || token === void 0 ? void 0 : token.symbol });
}
exports.TokenLogoAndSymbol = TokenLogoAndSymbol;
var TokenSelect = function (_a) {
    var onClick = _a.onClick, isSrc = _a.isSrc, _b = _a.hideArrow, hideArrow = _b === void 0 ? true : _b, _c = _a.className, className = _c === void 0 ? "" : _c, tokenSelectedUi = _a.tokenSelectedUi, tokenNotSelectedUi = _a.tokenNotSelectedUi, CustomArrow = _a.CustomArrow, customButtonElement = _a.customButtonElement;
    var srcToken = (0, store_1.useTwapStore)(function (state) { return state.srcToken; });
    var dstToken = (0, store_1.useTwapStore)(function (state) { return state.dstToken; });
    var token = isSrc ? srcToken : dstToken;
    return ((0, jsx_runtime_1.jsx)(material_2.Box, __assign({ className: "".concat(className, " twap-token-select") }, { children: token ? ((0, jsx_runtime_1.jsx)(styles_1.StyledRowFlex, __assign({ gap: 5, style: { cursor: "pointer" }, width: "fit-content", onClick: onClick, className: "twap-token-selected" }, { children: tokenSelectedUi ? ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: tokenSelectedUi })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(TokenLogoAndSymbol, { isSrc: isSrc }), !hideArrow && (0, jsx_runtime_1.jsx)(base_1.Icon, { icon: CustomArrow ? (0, jsx_runtime_1.jsx)(CustomArrow, { size: 20 }) : (0, jsx_runtime_1.jsx)(IoIosArrowDown_1.IoIosArrowDown, { size: 20 }) })] })) }))) : ((0, jsx_runtime_1.jsx)(TokenSelectButton_1.default, { customButtonElement: customButtonElement, customUi: tokenNotSelectedUi, hideArrow: hideArrow, className: "".concat(className, " twap-token-not-selected"), onClick: onClick })) })));
};
exports.TokenSelect = TokenSelect;
var TokenSelectNew = function (_a) {
    var onClick = _a.onClick, isSrc = _a.isSrc, _b = _a.hideArrow, hideArrow = _b === void 0 ? true : _b, _c = _a.className, className = _c === void 0 ? "" : _c, CustomArrow = _a.CustomArrow;
    var srcToken = (0, store_1.useTwapStore)(function (state) { return state.srcToken; });
    var dstToken = (0, store_1.useTwapStore)(function (state) { return state.dstToken; });
    var translations = (0, context_1.useTwapContext)().translations;
    var token = isSrc ? srcToken : dstToken;
    return ((0, jsx_runtime_1.jsx)(material_2.Box, __assign({ className: "".concat(className, " twap-token-select") }, { children: (0, jsx_runtime_1.jsxs)(material_1.Button, __assign({ onClick: onClick, className: "twap-token-selected" }, { children: [token ? (0, jsx_runtime_1.jsx)(TokenLogoAndSymbol, { isSrc: isSrc }) : (0, jsx_runtime_1.jsx)(styles_1.StyledOneLineText, { children: translations.selectToken }), !hideArrow && (0, jsx_runtime_1.jsx)(base_1.Icon, { icon: CustomArrow ? (0, jsx_runtime_1.jsx)(CustomArrow, { size: 20 }) : (0, jsx_runtime_1.jsx)(IoIosArrowDown_1.IoIosArrowDown, { size: 20 }) })] })) })));
};
exports.TokenSelectNew = TokenSelectNew;
var TokenSymbol = function (_a) {
    var isSrc = _a.isSrc, hideNull = _a.hideNull, onClick = _a.onClick;
    var token = (0, hooks_1.useToken)(isSrc);
    return (0, jsx_runtime_1.jsx)(base_1.TokenName, { onClick: onClick, hideNull: hideNull, name: token === null || token === void 0 ? void 0 : token.symbol });
};
exports.TokenSymbol = TokenSymbol;
function TradeIntervalSelector(_a) {
    var placeholder = _a.placeholder;
    var setFillDelay = (0, store_1.useTwapStore)(function (store) { return store.setFillDelay; });
    var fillDelay = (0, store_1.useTwapStore)(function (store) { return store.customFillDelay; });
    return (0, jsx_runtime_1.jsx)(base_1.TimeSelector, { placeholder: placeholder, onChange: setFillDelay, value: fillDelay });
}
exports.TradeIntervalSelector = TradeIntervalSelector;
var TokenSelectModal = function (_a) {
    var Component = _a.Component, isOpen = _a.isOpen, onClose = _a.onClose, _b = _a.isSrc, isSrc = _b === void 0 ? false : _b;
    var onTokenSelectedCallback = (0, hooks_1.useSelectTokenCallback)();
    var onSelect = (0, react_1.useCallback)(function (token) {
        onTokenSelectedCallback({ isSrc: isSrc, token: token });
        onClose();
    }, [onTokenSelectedCallback, isSrc]);
    if (!Component)
        return null;
    return (0, jsx_runtime_1.jsx)(Component, { isOpen: isOpen, onClose: onClose, onSelect: onSelect, srcTokenSelected: undefined, dstTokenSelected: undefined });
};
exports.TokenSelectModal = TokenSelectModal;
function LimitPriceToggle(_a) {
    var variant = _a.variant, style = _a.style;
    var loadingState = (0, hooks_1.useLoadingState)();
    var isLoading = loadingState.srcUsdLoading || loadingState.dstUsdLoading;
    var translations = (0, context_1.useTwapContext)().translations;
    var _b = (0, store_1.useTwapStore)(function (state) { return state.getLimitPrice(false); }), leftToken = _b.leftToken, rightToken = _b.rightToken;
    var isLimitOrder = (0, store_1.useTwapStore)(function (store) { return store.isLimitOrder; });
    var setLimitOrder = (0, store_1.useTwapStore)(function (store) { return store.setLimitOrder; });
    var selectTokensWarning = !leftToken || !rightToken;
    return ((0, jsx_runtime_1.jsx)(base_1.Tooltip, __assign({ text: isLoading ? "".concat(translations.loading, "...") : selectTokensWarning ? translations.selectTokens : "" }, { children: (0, jsx_runtime_1.jsx)(base_1.Switch, { style: style, variant: variant, disabled: !!selectTokensWarning || isLoading, value: isLimitOrder, onChange: function (value) { return setLimitOrder(value); } }) })));
}
exports.LimitPriceToggle = LimitPriceToggle;
function LimitPriceRadioGroup(_a) {
    var className = _a.className;
    var loadingState = (0, hooks_1.useLoadingState)();
    var isLoading = loadingState.srcUsdLoading || loadingState.dstUsdLoading;
    var _b = (0, store_1.useTwapStore)(function (state) { return state.getLimitPrice(false); }), leftToken = _b.leftToken, rightToken = _b.rightToken;
    var isLimitOrder = (0, store_1.useTwapStore)(function (store) { return store.isLimitOrder; });
    var setLimitOrder = (0, store_1.useTwapStore)(function (store) { return store.setLimitOrder; });
    var selectTokensWarning = !leftToken || !rightToken;
    var handleChange = function (event) {
        setLimitOrder(String(event.target.value) === "true");
    };
    return ((0, jsx_runtime_1.jsx)(material_2.FormControl, __assign({ className: "twap-radio ".concat(className), disabled: !!selectTokensWarning || isLoading }, { children: (0, jsx_runtime_1.jsxs)(material_2.RadioGroup, __assign({ row: true, name: "isLimitOrder", value: String(isLimitOrder), onChange: handleChange }, { children: [(0, jsx_runtime_1.jsx)(base_1.Radio, { label: "Market Price", value: "false" }), (0, jsx_runtime_1.jsx)(base_1.Radio, { label: "Limit Price", value: "true" })] })) })));
}
exports.LimitPriceRadioGroup = LimitPriceRadioGroup;
function ChunksUSD(_a) {
    var onlyValue = _a.onlyValue, emptyUi = _a.emptyUi, suffix = _a.suffix, prefix = _a.prefix;
    var usd = (0, store_1.useTwapStore)(function (state) { return state.getSrcChunkAmountUsdUi(); });
    var loading = (0, hooks_1.useLoadingState)().srcUsdLoading;
    return (0, jsx_runtime_1.jsx)(base_1.USD, { prefix: prefix, suffix: suffix, value: usd, onlyValue: onlyValue, emptyUi: emptyUi, isLoading: loading });
}
exports.ChunksUSD = ChunksUSD;
var TokenBalance = function (_a) {
    var isSrc = _a.isSrc, label = _a.label, showSymbol = _a.showSymbol, _b = _a.className, className = _b === void 0 ? "" : _b, hideLabel = _a.hideLabel, emptyUi = _a.emptyUi, decimalScale = _a.decimalScale;
    var srcBalance = (0, store_1.useTwapStore)(function (state) { return state.getSrcBalanceUi(); });
    var srcLoading = (0, hooks_1.useLoadingState)().srcBalanceLoading;
    var dstBalance = (0, store_1.useTwapStore)(function (state) { return state.getDstBalanceUi(); });
    var dstLoading = (0, hooks_1.useLoadingState)().dstBalanceLoading;
    var srcToken = (0, store_1.useTwapStore)(function (state) { return state.srcToken; });
    var dstToken = (0, store_1.useTwapStore)(function (state) { return state.dstToken; });
    var balance = isSrc ? srcBalance : dstBalance;
    var isLoading = isSrc ? srcLoading : dstLoading;
    var symbol = isSrc ? srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol : dstToken === null || dstToken === void 0 ? void 0 : dstToken.symbol;
    var suffix = !showSymbol ? undefined : isSrc ? srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol : dstToken === null || dstToken === void 0 ? void 0 : dstToken.symbol;
    return ((0, jsx_runtime_1.jsx)(base_1.Balance, { symbol: symbol || "", decimalScale: decimalScale, emptyUi: emptyUi, hideLabel: hideLabel, className: className, suffix: suffix, label: label, value: balance, isLoading: isLoading }));
};
exports.TokenBalance = TokenBalance;
function TokenUSD(_a) {
    var isSrc = _a.isSrc, emptyUi = _a.emptyUi, _b = _a.className, className = _b === void 0 ? "" : _b, onlyValue = _a.onlyValue, prefix = _a.prefix, suffix = _a.suffix, hideIfZero = _a.hideIfZero;
    var srcUSD = (0, store_1.useTwapStore)(function (state) { return state.getSrcAmountUsdUi(); });
    var srcLoading = (0, hooks_1.useLoadingState)().srcUsdLoading;
    var dstUSD = (0, store_1.useTwapStore)(function (state) { return state.getDstAmountUsdUi(); });
    var dstLoading = (0, hooks_1.useLoadingState)().dstUsdLoading;
    var usd = isSrc ? srcUSD : dstUSD;
    var isLoading = isSrc ? srcLoading : dstLoading;
    if (Number(usd) <= 0 && hideIfZero)
        return null;
    return (0, jsx_runtime_1.jsx)(base_1.USD, { suffix: suffix, prefix: prefix, onlyValue: onlyValue, className: className, emptyUi: emptyUi, value: usd || "0", isLoading: isLoading });
}
exports.TokenUSD = TokenUSD;
var SubmitButton = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, isMain = _a.isMain;
    var _c = (0, hooks_1.useSubmitButton)(isMain), loading = _c.loading, onClick = _c.onClick, disabled = _c.disabled, text = _c.text;
    return ((0, jsx_runtime_1.jsx)(base_1.Button, __assign({ className: "twap-submit ".concat(className), loading: loading, onClick: onClick || (function () { }), disabled: disabled }, { children: text })));
};
exports.SubmitButton = SubmitButton;
var useLimitPriceComponents = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? "0.00" : _b, showDefault = _a.showDefault, _c = _a.toggleIcon, toggleIcon = _c === void 0 ? (0, jsx_runtime_1.jsx)(HiSwitchHorizontal_1.HiSwitchHorizontal, { style: { width: 20, height: 20 } }) : _c, hideSymbol = _a.hideSymbol, reverse = _a.reverse;
    var isLimitOrder = (0, store_1.useTwapStore)(function (store) { return store.isLimitOrder; });
    var _d = (0, hooks_1.useLimitPrice)(), leftToken = _d.leftToken, rightToken = _d.rightToken, onChange = _d.onChange, limitPrice = _d.limitPrice, toggleInverted = _d.toggleInverted;
    var _isLimitOrder = isLimitOrder || showDefault;
    if (!_isLimitOrder || !leftToken || !rightToken)
        return null;
    return {
        leftToken: (0, jsx_runtime_1.jsx)(TokenDisplay_1.default, { reverse: reverse, hideSymbol: hideSymbol, singleToken: true, symbol: leftToken === null || leftToken === void 0 ? void 0 : leftToken.symbol, logo: leftToken === null || leftToken === void 0 ? void 0 : leftToken.logoUrl }),
        rightToken: (0, jsx_runtime_1.jsx)(TokenDisplay_1.default, { reverse: reverse, hideSymbol: hideSymbol, symbol: rightToken === null || rightToken === void 0 ? void 0 : rightToken.symbol, logo: rightToken === null || rightToken === void 0 ? void 0 : rightToken.logoUrl }),
        input: (0, jsx_runtime_1.jsx)(base_1.NumericInput, { placeholder: placeholder, onChange: onChange, value: limitPrice }),
        toggle: (0, jsx_runtime_1.jsx)(base_1.IconButton, { onClick: toggleInverted, icon: toggleIcon }),
    };
};
exports.useLimitPriceComponents = useLimitPriceComponents;
function LimitPriceInput(_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? "0.00" : _b, _c = _a.className, className = _c === void 0 ? "" : _c, showDefault = _a.showDefault, hideSymbol = _a.hideSymbol, reverse = _a.reverse;
    var components = (0, exports.useLimitPriceComponents)({ placeholder: placeholder, showDefault: showDefault, hideSymbol: hideSymbol, reverse: reverse });
    if (!components)
        return null;
    return ((0, jsx_runtime_1.jsxs)(StyledLimitPriceInput, __assign({ className: "twap-limit-price-input ".concat(className) }, { children: [(0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ gap: 10, style: { paddingLeft: 5 }, width: "fit-content" }, { children: [components.leftToken, (0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: "=" })] })), components.input, (0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ gap: 10, width: "fit-content" }, { children: [components.rightToken, components.toggle] }))] })));
}
exports.LimitPriceInput = LimitPriceInput;
var MarketPrice = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, hideLabel = _a.hideLabel;
    var _c = (0, hooks_1.useMarketPrice)(), toggleInverted = _c.toggleInverted, leftToken = _c.leftToken, rightToken = _c.rightToken, marketPrice = _c.marketPrice, loading = _c.loading;
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsxs)(StyledMarketPrice, __assign({ justifyContent: "space-between", className: "twap-market-price ".concat(className) }, { children: [!hideLabel && (0, jsx_runtime_1.jsx)(styles_1.StyledText, __assign({ className: "title" }, { children: translations.currentMarketPrice })), (0, jsx_runtime_1.jsx)(base_1.TokenPriceCompare, { loading: loading, leftToken: leftToken, rightToken: rightToken, price: marketPrice, toggleInverted: toggleInverted })] })));
};
exports.MarketPrice = MarketPrice;
var StyledMarketPrice = (0, material_1.styled)(styles_1.StyledRowFlex)({
    ".twap-token-logo": {
        minWidth: 22,
        minHeight: 22,
    },
});
function PoweredBy(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsx)(StyledPoweredBy, __assign({ className: "".concat(className, " twap-powered-by") }, { children: (0, jsx_runtime_1.jsxs)("a", __assign({ href: "https://www.orbs.com/", target: "_blank" }, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: translations.poweredBy }), (0, jsx_runtime_1.jsx)("img", { src: "https://raw.githubusercontent.com/orbs-network/twap-ui/master/logo/orbslogo.svg" })] })) })));
}
exports.PoweredBy = PoweredBy;
// --- warnings --- //
var Warning = function (_a) {
    var tootlip = _a.tootlip, warning = _a.warning;
    return ((0, jsx_runtime_1.jsx)(base_1.Tooltip, __assign({ text: tootlip }, { children: (0, jsx_runtime_1.jsxs)(StyledWarning, __assign({ justifyContent: "flex-start", gap: 5, className: "twap-warning" }, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: warning }), (0, jsx_runtime_1.jsx)(AiOutlineWarning_1.AiOutlineWarning, {})] })) })));
};
var PartialFillWarning = function () {
    var translations = (0, context_1.useTwapContext)().translations;
    var isWarning = (0, store_1.useTwapStore)(function (state) { return state.getIsPartialFillWarning(); });
    var lib = (0, store_1.useTwapStore)(function (state) { return state.lib; });
    if (!isWarning || !lib)
        return null;
    return (0, jsx_runtime_1.jsx)(Warning, { tootlip: translations.prtialFillWarningTooltip, warning: translations.prtialFillWarning });
};
exports.PartialFillWarning = PartialFillWarning;
var FillDelayWarning = function () {
    var translations = (0, context_1.useTwapContext)().translations;
    var fillDelayWarning = (0, store_1.useTwapStore)(function (store) { return store.getFillDelayWarning(); });
    var minimumDelayMinutes = (0, store_1.useTwapStore)(function (store) { return store.getMinimumDelayMinutes(); });
    var lib = (0, store_1.useTwapStore)(function (state) { return state.lib; });
    if (!fillDelayWarning || !lib)
        return null;
    return (0, jsx_runtime_1.jsx)(Warning, { tootlip: (0, store_1.handleFillDelayText)(translations.fillDelayWarningTooltip, minimumDelayMinutes), warning: translations.invalid });
};
exports.FillDelayWarning = FillDelayWarning;
/// --- order summary ---- ///
function TotalChunks() {
    var value = (0, store_1.useTwapStore)(function (store) { return store.getChunks(); });
    var formattedValue = (0, hooks_1.useFormatNumber)({ value: value });
    return ((0, jsx_runtime_1.jsx)(base_1.Tooltip, __assign({ text: formattedValue }, { children: (0, jsx_runtime_1.jsx)(styles_1.StyledOneLineText, { children: formattedValue }) })));
}
exports.TotalChunks = TotalChunks;
function ChunksAmount() {
    var value = (0, store_1.useTwapStore)(function (store) { return store.getSrcChunkAmountUi(); });
    var formattedValue = (0, hooks_1.useFormatNumber)({ value: value });
    if (!value)
        return null;
    return ((0, jsx_runtime_1.jsx)(base_1.Tooltip, __assign({ text: formattedValue }, { children: (0, jsx_runtime_1.jsx)(styles_1.StyledOneLineText, __assign({ className: "twap-chunks-amount" }, { children: formattedValue })) })));
}
exports.ChunksAmount = ChunksAmount;
var Deadline = function () {
    var deadline = (0, store_1.useTwapStore)(function (store) { return store.getDeadlineUi(); });
    return (0, jsx_runtime_1.jsx)(styles_1.StyledOneLineText, { children: deadline });
};
exports.Deadline = Deadline;
var OrderType = function () {
    var isLimitOrder = (0, store_1.useTwapStore)(function (store) { return store.isLimitOrder; });
    var translations = (0, context_1.useTwapContext)().translations;
    return (0, jsx_runtime_1.jsx)(styles_1.StyledOneLineText, { children: isLimitOrder ? translations.limitOrder : translations.marketOrder });
};
exports.OrderType = OrderType;
var TradeIntervalAsText = function () {
    var getFillDelayText = (0, store_1.useTwapStore)(function (store) { return store.getFillDelayText; });
    var translations = (0, context_1.useTwapContext)().translations;
    return (0, jsx_runtime_1.jsx)(styles_1.StyledOneLineText, { children: getFillDelayText(translations) });
};
exports.TradeIntervalAsText = TradeIntervalAsText;
var MinDstAmountOut = function () {
    var isLimitOrder = (0, store_1.useTwapStore)(function (store) { return store.isLimitOrder; });
    var translations = (0, context_1.useTwapContext)().translations;
    var dstMinAmountOutUi = (0, store_1.useTwapStore)(function (store) { return store.getDstMinAmountOutUi(); });
    var formattedValue = (0, hooks_1.useFormatNumber)({ value: dstMinAmountOutUi });
    if (!isLimitOrder) {
        return (0, jsx_runtime_1.jsx)(styles_1.StyledOneLineText, { children: translations.none });
    }
    return ((0, jsx_runtime_1.jsx)(base_1.Tooltip, __assign({ text: formattedValue }, { children: (0, jsx_runtime_1.jsx)(styles_1.StyledOneLineText, { children: formattedValue }) })));
};
exports.MinDstAmountOut = MinDstAmountOut;
var OrderSummaryDetailsMinDstAmount = function (_a) {
    var subtitle = _a.subtitle;
    return ((0, jsx_runtime_1.jsxs)(StyledSummaryRow, __assign({ className: "twap-order-summary-details-item" }, { children: [(0, jsx_runtime_1.jsx)(Labels_1.OrderSummaryMinDstAmountOutLabel, { subtitle: subtitle }), (0, jsx_runtime_1.jsx)(StyledSummaryRowRight, __assign({ className: "twap-order-summary-details-item-right" }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(TokenLogoAndSymbol, { isSrc: false, reverse: true }), (0, jsx_runtime_1.jsx)(exports.MinDstAmountOut, {})] }) }))] })));
};
exports.OrderSummaryDetailsMinDstAmount = OrderSummaryDetailsMinDstAmount;
var OrderSummaryDetailsTradeInterval = function (_a) {
    var subtitle = _a.subtitle;
    return ((0, jsx_runtime_1.jsxs)(StyledSummaryRow, __assign({ className: "twap-order-summary-details-item" }, { children: [(0, jsx_runtime_1.jsx)(Labels_1.OrderSummaryTradeIntervalLabel, { subtitle: subtitle }), (0, jsx_runtime_1.jsx)(StyledSummaryRowRight, __assign({ className: "twap-order-summary-details-item-right" }, { children: (0, jsx_runtime_1.jsx)(exports.TradeIntervalAsText, {}) }))] })));
};
exports.OrderSummaryDetailsTradeInterval = OrderSummaryDetailsTradeInterval;
var OrderSummaryDetailsTotalChunks = function (_a) {
    var subtitle = _a.subtitle;
    return ((0, jsx_runtime_1.jsxs)(StyledSummaryRow, __assign({ className: "twap-order-summary-details-item" }, { children: [(0, jsx_runtime_1.jsx)(Labels_1.OrderSummaryTotalChunksLabel, { subtitle: subtitle }), (0, jsx_runtime_1.jsx)(StyledSummaryRowRight, __assign({ className: "twap-order-summary-details-item-right" }, { children: (0, jsx_runtime_1.jsx)(TotalChunks, {}) }))] })));
};
exports.OrderSummaryDetailsTotalChunks = OrderSummaryDetailsTotalChunks;
var OrderSummaryDetailsChunkSize = function (_a) {
    var subtitle = _a.subtitle;
    return ((0, jsx_runtime_1.jsxs)(StyledSummaryRow, __assign({ className: "twap-order-summary-details-item" }, { children: [(0, jsx_runtime_1.jsx)(Labels_1.OrderSummaryChunkSizeLabel, { subtitle: subtitle }), (0, jsx_runtime_1.jsx)(StyledSummaryRowRight, __assign({ className: "twap-order-summary-details-item-right" }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(TokenLogoAndSymbol, { isSrc: true, reverse: true }), (0, jsx_runtime_1.jsx)(ChunksAmount, {})] }) }))] })));
};
exports.OrderSummaryDetailsChunkSize = OrderSummaryDetailsChunkSize;
var OrderSummaryDetailsOrderType = function (_a) {
    var subtitle = _a.subtitle;
    return ((0, jsx_runtime_1.jsxs)(StyledSummaryRow, __assign({ className: "twap-order-summary-details-item" }, { children: [(0, jsx_runtime_1.jsx)(Labels_1.OrderSummaryOrderTypeLabel, { subtitle: subtitle }), (0, jsx_runtime_1.jsx)(StyledSummaryRowRight, __assign({ className: "twap-order-summary-details-item-right" }, { children: (0, jsx_runtime_1.jsx)(exports.OrderType, {}) }))] })));
};
exports.OrderSummaryDetailsOrderType = OrderSummaryDetailsOrderType;
var OrderSummaryDetailsDeadline = function (_a) {
    var subtitle = _a.subtitle;
    return ((0, jsx_runtime_1.jsxs)(StyledSummaryRow, __assign({ className: "twap-order-summary-details-item" }, { children: [(0, jsx_runtime_1.jsx)(Labels_1.OrderSummaryDeadlineLabel, { subtitle: subtitle }), (0, jsx_runtime_1.jsx)(StyledSummaryRowRight, __assign({ className: "twap-order-summary-details-item-right" }, { children: (0, jsx_runtime_1.jsx)(exports.Deadline, {}) }))] })));
};
exports.OrderSummaryDetailsDeadline = OrderSummaryDetailsDeadline;
var OrderSummaryDetails = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, subtitle = _a.subtitle;
    return ((0, jsx_runtime_1.jsxs)(StyledSummaryDetails, __assign({ className: "twap-order-summary-details ".concat(className) }, { children: [(0, jsx_runtime_1.jsx)(exports.OrderSummaryDetailsDeadline, { subtitle: subtitle }), (0, jsx_runtime_1.jsx)(exports.OrderSummaryDetailsOrderType, { subtitle: subtitle }), (0, jsx_runtime_1.jsx)(exports.OrderSummaryDetailsChunkSize, { subtitle: subtitle }), (0, jsx_runtime_1.jsx)(exports.OrderSummaryDetailsTotalChunks, { subtitle: subtitle }), (0, jsx_runtime_1.jsx)(exports.OrderSummaryDetailsTradeInterval, { subtitle: subtitle }), (0, jsx_runtime_1.jsx)(exports.OrderSummaryDetailsMinDstAmount, { subtitle: subtitle })] })));
};
exports.OrderSummaryDetails = OrderSummaryDetails;
function OrderSummarySwipeContainer(_a) {
    var children = _a.children;
    var showConfirmation = (0, store_1.useTwapStore)(function (store) { return store.showConfirmation; });
    var setShowConfirmation = (0, store_1.useTwapStore)(function (store) { return store.setShowConfirmation; });
    return ((0, jsx_runtime_1.jsx)(base_1.SwipeContainer, __assign({ show: showConfirmation, close: function () { return setShowConfirmation(false); } }, { children: children })));
}
exports.OrderSummarySwipeContainer = OrderSummarySwipeContainer;
function OrderSummaryModalContainer(_a) {
    var children = _a.children, className = _a.className;
    var showConfirmation = (0, store_1.useTwapStore)(function (store) { return store.showConfirmation; });
    var setShowConfirmation = (0, store_1.useTwapStore)(function (store) { return store.setShowConfirmation; });
    return ((0, jsx_runtime_1.jsx)(base_1.Modal, __assign({ open: showConfirmation, className: className, onClose: function () { return setShowConfirmation(false); } }, { children: children })));
}
exports.OrderSummaryModalContainer = OrderSummaryModalContainer;
var OrderSummaryTokenDisplay = function (_a) {
    var isSrc = _a.isSrc, usdSuffix = _a.usdSuffix, usdPrefix = _a.usdPrefix;
    var translations = (0, context_1.useTwapContext)().translations;
    var isLimitOrder = (0, store_1.useTwapStore)(function (store) { return store.isLimitOrder; });
    var srcAmount = (0, store_1.useTwapStore)(function (store) { return store.srcAmountUi; });
    var dstAmount = (0, store_1.useTwapStore)(function (store) { return store.getDstAmountUi(); });
    var amount = isSrc ? srcAmount : dstAmount;
    var prefix = isSrc ? "" : isLimitOrder ? "≥ " : "~ ";
    return ((0, jsx_runtime_1.jsxs)(StyledOrderSummaryTokenDisplay, __assign({ className: "twap-orders-summary-token-display" }, { children: [(0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ className: "twap-orders-summary-token-display-flex" }, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: isSrc ? translations.from : translations.to }), (0, jsx_runtime_1.jsx)(TokenUSD, { prefix: usdPrefix, suffix: usdSuffix, isSrc: isSrc })] })), (0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ className: "twap-orders-summary-token-display-flex" }, { children: [(0, jsx_runtime_1.jsx)(TokenLogoAndSymbol, { isSrc: isSrc }), (0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ className: "twap-orders-summary-token-display-amount" }, { children: [prefix && (0, jsx_runtime_1.jsxs)(styles_1.StyledText, { children: [" ", prefix] }), (0, jsx_runtime_1.jsx)(styles_1.StyledOneLineText, { children: amount })] }))] }))] })));
};
exports.OrderSummaryTokenDisplay = OrderSummaryTokenDisplay;
var AcceptDisclaimer = function (_a) {
    var variant = _a.variant, className = _a.className;
    var translations = (0, context_1.useTwapContext)().translations;
    var setDisclaimerAccepted = (0, store_1.useTwapStore)(function (store) { return store.setDisclaimerAccepted; });
    var disclaimerAccepted = (0, store_1.useTwapStore)(function (store) { return store.disclaimerAccepted; });
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ gap: 5, justifyContent: "space-between", className: "twap-disclaimer-switch ".concat(className) }, { children: [(0, jsx_runtime_1.jsx)(base_1.Label, { children: translations.acceptDisclaimer }), (0, jsx_runtime_1.jsx)(base_1.Switch, { variant: variant, value: disclaimerAccepted, onChange: function () { return setDisclaimerAccepted(!disclaimerAccepted); } })] })));
};
exports.AcceptDisclaimer = AcceptDisclaimer;
var OutputAddress = function (_a) {
    var className = _a.className;
    var maker = (0, store_1.useTwapStore)(function (store) { var _a; return (_a = store.lib) === null || _a === void 0 ? void 0 : _a.maker; });
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsxs)(StyledOutputAddress, __assign({ className: "twap-order-summary-output-address ".concat(className) }, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledText, __assign({ style: { textAlign: "center", width: "100%" }, className: "text" }, { children: translations.outputWillBeSentTo })), (0, jsx_runtime_1.jsx)(base_1.Tooltip, __assign({ childrenStyles: { width: "100%" }, text: maker }, { children: (0, jsx_runtime_1.jsx)(styles_1.StyledOneLineText, __assign({ style: { textAlign: "center", width: "100%" }, className: "address" }, { children: maker })) }))] })));
};
exports.OutputAddress = OutputAddress;
var StyledOutputAddress = (0, material_1.styled)(styles_1.StyledColumnFlex)({});
var OrderSummaryLimitPriceToggle = function () {
    var _a = (0, hooks_1.useLimitPrice)(), isLimitOrder = _a.isLimitOrder, toggleInverted = _a.toggleInverted, limitPrice = _a.limitPrice, leftToken = _a.leftToken, rightToken = _a.rightToken;
    var translations = (0, context_1.useTwapContext)().translations;
    return isLimitOrder ? ((0, jsx_runtime_1.jsx)(base_1.TokenPriceCompare, { leftToken: leftToken, rightToken: rightToken, price: limitPrice, toggleInverted: toggleInverted })) : ((0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: translations.none }));
};
exports.OrderSummaryLimitPriceToggle = OrderSummaryLimitPriceToggle;
var OrderSummaryPriceCompare = function () {
    var _a = (0, hooks_1.useLimitPrice)(), isLimitOrder = _a.isLimitOrder, toggleInverted = _a.toggleInverted, limitPrice = _a.limitPrice, leftToken = _a.leftToken, rightToken = _a.rightToken;
    var market = (0, hooks_1.useMarketPrice)();
    if (isLimitOrder) {
        return (0, jsx_runtime_1.jsx)(base_1.TokenPriceCompare, { leftToken: leftToken, rightToken: rightToken, price: limitPrice, toggleInverted: toggleInverted });
    }
    return (0, jsx_runtime_1.jsx)(base_1.TokenPriceCompare, { leftToken: market.leftToken, rightToken: market.rightToken, price: market.marketPrice, toggleInverted: market.toggleInverted });
};
exports.OrderSummaryPriceCompare = OrderSummaryPriceCompare;
var OrderSummaryLimitPrice = function () {
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ className: "twap-order-summary-limit-price", justifyContent: "space-between" }, { children: [(0, jsx_runtime_1.jsx)(base_1.Label, __assign({ tooltipText: translations.confirmationLimitPriceTooltip }, { children: translations.limitPrice })), (0, jsx_runtime_1.jsx)(exports.OrderSummaryLimitPriceToggle, {})] })));
};
exports.OrderSummaryLimitPrice = OrderSummaryLimitPrice;
var DisclaimerText = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    var translations = (0, context_1.useTwapContext)().translations;
    var lib = (0, store_1.useTwapStore)(function (state) { return state.lib; });
    return ((0, jsx_runtime_1.jsxs)(StyledTradeInfoExplanation, __assign({ className: "twap-disclaimer-text ".concat(className) }, { children: [(0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: translations.disclaimer1 }), (0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: translations.disclaimer2 }), (0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: translations.disclaimer3 }), (0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: translations.disclaimer4 }), (0, jsx_runtime_1.jsx)(styles_1.StyledText, { children: translations.disclaimer5.replace("{{dex}}", (lib === null || lib === void 0 ? void 0 : lib.config.name) || "DEX") }), (0, jsx_runtime_1.jsxs)(styles_1.StyledText, { children: [translations.disclaimer6, " ", (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://github.com/orbs-network/twap", target: "_blank" }, { children: translations.link })), ". ", translations.disclaimer7, " ", (0, jsx_runtime_1.jsx)("a", __assign({ href: "https://github.com/orbs-network/twap/blob/master/TOS.md", target: "_blank" }, { children: translations.link })), "."] })] })));
};
exports.DisclaimerText = DisclaimerText;
//---- styles -----//
var StyledWarning = (0, material_1.styled)(styles_1.StyledRowFlex)({
    p: {
        fontSize: 14,
        color: "#E23D5B",
    },
    "& *": {
        fill: "#E23D5B",
    },
});
var StyledLimitPriceInput = (0, material_1.styled)(styles_1.StyledRowFlex)({
    paddingLeft: 10,
    "& .twap-input": {
        flex: 1,
        "& input": {
            fontSize: 16,
            textAlign: "center",
        },
    },
    ".twap-token-logo": {
        width: 24,
        height: 24,
    },
    "& .twap-token-name, p": {
        fontSize: 14,
        position: "relative",
    },
});
var StyledChunksInput = (0, material_1.styled)(base_1.NumericInput)({
    width: 70,
    height: 35,
    input: {
        fontSize: 16,
        textAlign: "center",
        width: "100%",
        transition: "0.2s all",
    },
});
var StyledChunksSliderSelect = (0, material_1.styled)(base_1.Slider)({
    flex: 1,
    width: "auto",
    marginLeft: 30,
});
var StyledTradeInfoExplanation = (0, material_1.styled)(styles_1.StyledColumnFlex)({
    maxHeight: 140,
    overflow: "auto",
    gap: 10,
    "*": {
        fontSize: 16,
    },
});
var StyledOrderSummaryTokenDisplay = (0, material_1.styled)(styles_1.StyledColumnFlex)({
    ".twap-token-logo": {},
    ".twap-token-name": {
        fontSize: 16,
    },
    ".twap-orders-summary-token-display-amount": {
        fontSize: 19,
        justifyContent: "flex-end",
        width: "auto",
    },
    ".twap-orders-summary-token-display-flex": {
        justifyContent: "space-between",
    },
});
var StyledSummaryRowRight = (0, material_1.styled)(styles_1.StyledOverflowContainer)({
    flex: 1,
    width: "unset",
    justifyContent: "flex-end",
    ".twap-token-logo": {
        width: 22,
        height: 22,
        minWidth: 22,
        minHeight: 22,
    },
});
var StyledSummaryDetails = (0, material_1.styled)(styles_1.StyledColumnFlex)({
    gap: 15,
});
var StyledSummaryRow = (0, material_1.styled)(styles_1.StyledRowFlex)({
    justifyContent: "space-between",
    width: "100%",
    ".twap-label": {
        minWidth: 0,
        maxWidth: "60%",
    },
    "@media(max-width: 700px)": {
        flexDirection: "column",
        alignItems: "flex-start",
        ".twap-label": {
            maxWidth: "unset",
        },
    },
});
var StyledPoweredBy = (0, material_1.styled)(styles_1.StyledRowFlex)({
    marginTop: 10,
    marginBottom: 10,
    "& p": {
        color: "inherit",
    },
    "& a": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textDecoration: "unset",
        gap: 8,
    },
    "& img": {
        width: 20,
        height: 20,
        objectFit: "contain",
    },
});
var TradeSizeValue = function (_a) {
    var symbol = _a.symbol;
    var value = (0, store_1.useTwapStore)(function (store) { return store.getSrcChunkAmountUi(); });
    var formattedValue = (0, hooks_1.useFormatNumber)({ value: value });
    var srcToken = (0, store_1.useTwapStore)(function (store) { return store.srcToken; });
    var formattedValueTooltip = (0, hooks_1.useFormatNumber)({ value: value, decimalScale: 18 });
    if (!formattedValue || formattedValue === "0") {
        return (0, jsx_runtime_1.jsx)(material_2.Typography, __assign({ className: "twap-trade-size-value" }, { children: "-" }));
    }
    return ((0, jsx_runtime_1.jsx)(base_1.Tooltip, __assign({ text: "".concat(symbol ? "".concat(formattedValueTooltip, " ").concat(srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol) : formattedValueTooltip) }, { children: (0, jsx_runtime_1.jsx)(material_2.Typography, __assign({ className: "twap-trade-size-value" }, { children: "".concat(symbol ? "".concat(formattedValue, " ").concat(srcToken === null || srcToken === void 0 ? void 0 : srcToken.symbol) : formattedValue) })) })));
};
exports.TradeSizeValue = TradeSizeValue;
var TradeSize = function (_a) {
    var hideLabel = _a.hideLabel, hideSymbol = _a.hideSymbol;
    var srcToken = (0, store_1.useTwapStore)(function (store) { return store.srcToken; });
    var dsToken = (0, store_1.useTwapStore)(function (store) { return store.dstToken; });
    if (!srcToken && !dsToken) {
        return (0, jsx_runtime_1.jsx)("span", { children: "0" });
    }
    if (!srcToken && !hideLabel) {
        return (0, jsx_runtime_1.jsx)(Labels_1.ChunksAmountLabel, {});
    }
    return ((0, jsx_runtime_1.jsxs)(StyledTradeSize, { children: [!hideLabel && (0, jsx_runtime_1.jsx)(Labels_1.ChunksAmountLabel, {}), (0, jsx_runtime_1.jsxs)(styles_1.StyledRowFlex, __assign({ gap: 7, className: "content" }, { children: [(0, jsx_runtime_1.jsx)(exports.TokenLogo, { isSrc: true }), (0, jsx_runtime_1.jsx)(exports.TradeSizeValue, { symbol: !hideSymbol })] }))] }));
};
exports.TradeSize = TradeSize;
var StyledTradeSize = (0, material_1.styled)(styles_1.StyledRowFlex)(__assign(__assign({ width: "auto", gap: 10 }, styles_1.textOverflow), { minWidth: 0, ".content": {
        ".twap-token-logo": {
            width: 21,
            height: 21,
        },
        ".value": __assign({}, styles_1.textOverflow),
        p: {
            paddingTop: 2,
        },
        "*": {
            fontFamily: "inherit",
            fontSize: 14,
        },
    }, ".twap-label": {
        whiteSpace: "nowrap",
    } }));
var WarningMessage = function (_a) {
    var className = _a.className;
    var translations = (0, context_1.useTwapContext)().translations;
    var warning = (0, store_1.useTwapStore)(function (state) { return state.getFillWarning(translations); });
    if (!warning)
        return null;
    if (warning === translations.selectTokens || warning === translations.enterAmount) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(material_2.Fade, __assign({ in: true }, { children: (0, jsx_runtime_1.jsxs)(StyledMsg, __assign({ className: "twap-warning-msg ".concat(className) }, { children: [(0, jsx_runtime_1.jsx)(AiOutlineWarning_1.AiOutlineWarning, {}), (0, jsx_runtime_1.jsx)(material_2.Typography, { children: warning })] })) })));
};
exports.WarningMessage = WarningMessage;
var StyledMsg = (0, material_1.styled)(styles_1.StyledRowFlex)({
    flexWrap: "wrap",
    justifyContent: "flex-start",
    padding: "10px 12px",
});
var CopyTokenAddress = function (_a) {
    var isSrc = _a.isSrc;
    var srcToken = (0, store_1.useTwapStore)(function (store) { return store.srcToken; });
    var dstToken = (0, store_1.useTwapStore)(function (store) { return store.dstToken; });
    var address = isSrc ? srcToken === null || srcToken === void 0 ? void 0 : srcToken.address : dstToken === null || dstToken === void 0 ? void 0 : dstToken.address;
    return (0, jsx_runtime_1.jsx)(Copy_1.default, { value: address });
};
exports.CopyTokenAddress = CopyTokenAddress;
var ResetLimitButton = function (_a) {
    var children = _a.children;
    var setLimitOrderPriceUi = (0, store_1.useTwapStore)(function (store) { return store.setLimitOrderPriceUi; });
    var custom = (0, hooks_1.useLimitPrice)().custom;
    var onClick = function () {
        setLimitOrderPriceUi();
    };
    if (!custom)
        return null;
    return ((0, jsx_runtime_1.jsx)(base_1.Tooltip, __assign({ text: "Reset to market price" }, { children: children ? ((0, jsx_runtime_1.jsx)("span", __assign({ onClick: onClick, className: "twap-limit-reset" }, { children: children }))) : ((0, jsx_runtime_1.jsx)(base_1.IconButton, __assign({ onClick: onClick, className: "twap-limit-reset" }, { children: (0, jsx_runtime_1.jsx)(base_1.Icon, { icon: (0, jsx_runtime_1.jsx)(GrPowerReset_1.GrPowerReset, { style: { width: 18, height: 18 } }) }) }))) })));
};
exports.ResetLimitButton = ResetLimitButton;
var SrcToken = function () {
    return ((0, jsx_runtime_1.jsxs)(__1.Styles.StyledRowFlex, __assign({ style: { width: "auto" } }, { children: [(0, jsx_runtime_1.jsx)(exports.TokenLogo, { isSrc: true }), (0, jsx_runtime_1.jsx)(exports.TokenSymbol, { isSrc: true })] })));
};
exports.SrcToken = SrcToken;
var DstToken = function () {
    return ((0, jsx_runtime_1.jsxs)(__1.Styles.StyledRowFlex, __assign({ style: { width: "auto" } }, { children: [(0, jsx_runtime_1.jsx)(exports.TokenLogo, {}), (0, jsx_runtime_1.jsx)(exports.TokenSymbol, {})] })));
};
exports.DstToken = DstToken;
var TxLoading = function () {
    var _a = (0, store_1.useTwapStore)(), showLoadingModal = _a.showLoadingModal, setShowLodingModal = _a.setShowLodingModal;
    return (0, jsx_runtime_1.jsx)(PendingTxModal_1.default, { open: showLoadingModal, onClose: function () { return setShowLodingModal(false); } });
};
exports.TxLoading = TxLoading;
var TxSuccess = function () {
    var _a = (0, store_1.useTwapStore)(), showSuccessModal = _a.showSuccessModal, setShowSuccessModal = _a.setShowSuccessModal;
    return (0, jsx_runtime_1.jsx)(SuccessTxModal_1.default, { open: showSuccessModal, onClose: function () { return setShowSuccessModal(false); } });
};
exports.TxSuccess = TxSuccess;
